$(function() {
    let elementCount = $("[data-orders]").data("orders");
    let limitValue = $("[data-order-per-page]").data("order-per-page")
    $(".js-viewed-orders").text($(".table-profile__body tr").length)
    $(".js-order-history-select").on("change", function (){
        let status = $(this).val();
        let action = ($(this).hasClass("js-history-part")) ? "part" : "full"
        let offset = 0;
        let limit = limitValue;
        if (status === ""){
            window.historyLimit = limitValue;
            window.historyOffset = limitValue;
            offset = 0;
            limit = limitValue
        }
        window.historyOrderStatus = status;
        let data ={
            action: action,
            limit: limit,
            offset: offset,
            order_status: window.historyOrderStatus
        };
        sendAjax(data, function (){$(".table-profile__body").find("tr").remove()})
    })
    $(".js-order-history-more").on("click", function (){
        let action = ($(this).hasClass("js-history-part")) ? "part" : "full"
        let offset = $(".table-profile__body tr").length;
        let limit = 0;
        if (action == "full"){
            limit = elementCount
        }else{
            limit = window.historyLimit ? window.historyLimit : limitValue;
        }
        let data = {
           action: action,
           limit: limit,
           offset: offset,
           order_status: window.historyOrderStatus
        }
        sendAjax(data, function (){ window.historyOffset = $(".table-profile__body tr").length })
    })
    $(document).on("click", ".table-profile__tr", function (){
       let link = $(this).find("a[href]");
       if (link.length > 0){
           window.location.href = link.attr("href");
       }
    });
    function sendAjax(data, callback){
        if (window.xhr_load_orders && window.xhr_load_orders.readyState != 4){
            window.xhr_load_orders.abort();
        }
        window.xhr_load_orders = $.post(
            "/local/ajax/load_orders.php",
            data,
            function(_response) {
                if (typeof callback === "function"){
                    callback();
                }
                let parent = $(".table-profile__body");
                for (let id in _response["items"]){
                    let item = _response["items"][id];
                    let tr = $("<tr>").addClass("table-profile__tr")
                    let tdNo = $("<td>").addClass("table-profile__td semibold table-profile__td--history").data("td", "№: ").html("<a href='?ID=" +item["ACCOUNT_NUMBER"]+ "'>" + item["ACCOUNT_NUMBER"] + "</a>");
                    let tdDate = $("<td>").addClass("table-profile__td").data("td", window.pmMessages.orderDate + ": ").html(item["DATE_INSERT_FORMAT"]);
                    let tdStatus = $("<td>").addClass("table-profile__td").data("td", window.pmMessages.orderStatus + ": ").html(item["STATUS_NAME"]);
                    let tdPayment = $("<td>").addClass("table-profile__td").data("td", window.pmMessages.paymentStatus + ": ").html(item["PAYED"] == "N" ? window.pmMessages.paymentPending : window.pmMessages.paymentPaid);
                    let tdSum = $("<td>").addClass("table-profile__td").data("td", window.pmMessages.sum + ": ").html(item["PRICE"]);
                    tr.append(tdNo.prop('outerHTML'))
                    tr.append(tdDate.prop('outerHTML'))
                    tr.append(tdStatus.prop('outerHTML'))
                    tr.append(tdPayment.prop('outerHTML'))
                    tr.append(tdSum.prop('outerHTML'))
                    parent.append(tr);
                }
                $('.js-total-orders').html(_response["hide"]);
                $('.js-viewed-orders').html(parent.find("tr").length)
                if (_response["hide"] <= parent.find("tr").length){
                    $(".profile-history-buttons").hide();
                }else{
                    $(".profile-history-buttons").show();
                }
            },
            'json'
        );
    }
})
